export  const API_Options = {
  method: 'GET',
  headers: {
    accept: 'application/json',
    Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI0NWI1ZjIwN2M0MTIyNTQxMDA1ZWE0YmMwYzlmM2Q5MCIsIm5iZiI6MTc1NTE3NjM3OC41NzksInN1YiI6IjY4OWRkZGJhZmYyMGZjOTQyOGM3MDdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.SyI8wa9ASqUw-wVE7dtZ9MQg7mZ-Cc8IxzUlYUm0nYE'
  }
};

export const IMG_CDN = "https://image.tmdb.org/t/p/w500";

export const SUPPORTED_LANGUAGES = [{identifier: "en", name: "English"}, 
  {identifier: "hindi", name: "Hindi"}, {identifier: "telugu", name: "Telugu"}]

export const OPENAI_KEY =process.env.REACT_APP_OPENAI_API_KEY;
console.log(OPENAI_KEY);